module.exports = __webpack_public_path__ + "img/myposition_wf.a561428b.svg";